import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useTranslation } from 'react-i18next';
import Error from '../../Error';
import { ComparisonTypes } from '../../../../../../types/IStreamFilter';
import ValueInput from '../../../ValueInput';
import { IColumn } from '../../../../../../types/IColumn';

interface Props {
  comparison: ComparisonTypes;
  column: IColumn;
}

const ValuesSelect: React.FC<Props> = ({ comparison, column }) => {
  const { t } = useTranslation('filters');

  const { control, errors } = useFormContext();

  if (![ComparisonTypes.In, ComparisonTypes.NotIn].includes(comparison)) {
    return null;
  }

  return (
    <>
      <Controller
        render={({ onChange, value }) => (
          <ValueInput
            onChange={(values) => {
              onChange(values);
            }}
            isMulti
            column={column}
            defaultValue={value}
            label={t('Values')}
          />
        )}
        label={t('Value')}
        name="values"
        control={control}
        rules={{
          required: true,
          validate: (v) => v.length > 0,
        }}
      />
      <ErrorMessage
        render={({ message }) => <Error>{message}</Error>}
        errors={errors}
        name="values"
        message={t('required')}
      />
    </>
  );
};

export default ValuesSelect;
